export default "__VITE_ASSET__533601dd__"